import script from "./UseSoloPermissionLegend.vue?vue&type=script&setup=true&lang=js"
export * from "./UseSoloPermissionLegend.vue?vue&type=script&setup=true&lang=js"

import "./UseSoloPermissionLegend.vue?vue&type=style&index=0&id=f40acfc6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f40acfc6"]])

export default __exports__